var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v("\n  footer\n")])}
var staticRenderFns = []

export { render, staticRenderFns }